import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        ConfirmDialogModule,
        ButtonModule,
        DropdownModule,
        CalendarModule,
        TableModule,
        ToastModule,
        TabViewModule,
        RadioButtonModule,
        CheckboxModule,
        MultiSelectModule
    ],
    declarations: [
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        ConfirmDialogModule,
        ButtonModule,
        DropdownModule,
        CalendarModule,
        TableModule,
        ToastModule,
        TabViewModule,
        RadioButtonModule,
        CheckboxModule,
        MultiSelectModule
    ],
    entryComponents: [],
    providers: []
  })
  export class SharedModule { }
